import React from 'react'
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

import { VisitorInfoItem } from './visitor-info-item'

import { dndReorder } from 'helpers/drag-and-drop'

import { VisitorInfoPage, Amenity } from 'generated/mos/org/getty/visitorinfo'

import { VisitorInfoPages } from '../../store'

type Props = {
  readonly orderedPages: VisitorInfoPages['pages'];
  readonly setOrderedPages: React.Dispatch<React.SetStateAction<VisitorInfoPages['pages'] | undefined>>;
  readonly deleteHandler: (info: VisitorInfoPage.Entity) => void;
  readonly updateHandler: (info: VisitorInfoPage.Entity) => void;
  readonly deleteAmenityHandler: (page: VisitorInfoPage.Entity, amenity: Amenity.Entity) => void;
  readonly updateAmenityHandler: (amenity: Amenity.Entity) => void;
  readonly createAmenityHandler: (ref: VisitorInfoPage.Ref) => void;
}

export const ReorderablePages = ({ orderedPages, setOrderedPages, deleteHandler, updateHandler, updateAmenityHandler, deleteAmenityHandler, createAmenityHandler }: Props) => {
  const setOrderedAmenities = (pageRef: VisitorInfoPage.Ref) => (amenities: ReadonlyArray<Amenity.Entity>) => {
    const updatedAmenities = orderedPages.map(pageItem => {
      if(pageItem.page.ref === pageRef) {
        return {
          ...pageItem,
          amenities,
        }
      }
      return pageItem
    })
    setOrderedPages(updatedAmenities)
  }
  return (
    <DragDropContext onDragEnd={dropResult => setOrderedPages(dndReorder(dropResult, orderedPages))}>
      <Droppable droppableId="pages-list">
        {(provided) => (
          <div
            ref={provided.innerRef}
            {...provided.droppableProps}
          >
            {orderedPages.map(({ page, amenities }, index) => {
              const id = page.ref ? page.ref.id : ''
              return (
                <Draggable draggableId={id} key={id} index={index}>
                  {(provided, snapshot) => (
                    <div
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                    >
                      <VisitorInfoItem
                        isDragging={snapshot.isDragging}
                        draggableIndex={index}
                        page={page}
                        amenities={amenities}
                        updateHandler={updateHandler}
                        deleteHandler={deleteHandler}
                        updateAmenityHandler={updateAmenityHandler}
                        deleteAmenityHandler={deleteAmenityHandler}
                        createAmenityHandler={createAmenityHandler}
                        setOrderedAmenities={setOrderedAmenities(VisitorInfoPage.mustRef(page.ref))}
                      />
                    </div>
                  )}
                </Draggable>
              )
            })}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  )
}
